import { NgOptimizedImage, NgTemplateOutlet } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { BildungsangebotTerminDetail } from '../../../../../model';
import { SanitizerService } from '../../../../../services/sanitizer.service';
import { GeoisMapComponent } from '../../../../geois-map/geois-map.component';

@Component({
  selector: 'now-wbsuche-lib-veranstaltungsort',
  templateUrl: './veranstaltungsort.component.html',
  standalone: true,
  imports: [GeoisMapComponent, NgOptimizedImage, NgTemplateOutlet]
})
export class VeranstaltungsortComponent {
  private readonly sanitizerService = inject(SanitizerService);

  @Input()
  public termin!: BildungsangebotTerminDetail;

  @Input()
  public collapsed?: boolean;

  sanitizeFunction(html?: string): string {
    return this.sanitizerService.sanitize(html);
  }

  blurWithMessage(): string {
    if (this?.termin?.adresse?.ort === undefined) {
      return 'Die Kartenansicht ist für dieses Angebot nicht verfügbar.';
    }
    /*if (this.termin?.adresse?.?.land?.laenderCode !== 'D') {
      return 'Die Kartenansicht ist für dieses Land nicht verfügbar.';
    }*/
    return '';
  }
}
